/**
 * Created by lu on 2018/4/8.
 */
var nb = require('../../../nb');
var util = require('../../../util');

var wxLogin = require('../../../io/' + process.env.APP_ENV + '/wxLogin'); //微信登录
var io = require('../../../io/' + process.env.APP_ENV + '/io');
var getBannerList = require('../../../io/' + process.env.APP_ENV + '/index/getBannerList'); //banner数据
var getProductList = require('../../../io/' + process.env.APP_ENV + '/index/getProductList'); //商品推荐数据
var getWineRecommend = require('../../../io/' + process.env.APP_ENV + '/index/getWineRecommend'); //酒类推荐数据
var getBrandRecommend = require('../../../io/' + process.env.APP_ENV + '/index/getBrandRecommend'); //品牌推荐数据

var companyId;
module.exports = nb.define({
    parent: nb.Model,
    mapping: {
        banner: require('./banner/Banner'),
        products: require('./products/Products'),  //商品推荐
        typeList: require('./wineType/TypeList'),  //酒类推荐
        register: require('./register/Register'),  //采购流程
        brandList: require('./brand/BrandList'),   //品牌推荐
        bottom: require('./Bottom')                //提交邮箱
    },
    method: {
        init: function () {
            var seq = 0;
            var products = this.get('products');
            this.set('seq', seq);  //拿到所有接口状态

            //微信登录
            nb.model.onChange(nb.opts.clientReady, function (inEvent) {
                var param = util.getParam();
                var code = param['code'];
                var state = param['state'];
                this.set('code', code);
                if (!code && state !== "wechat") {
                    return;
                }
                this._wxLogin();
            }, this);

            this.onChange('seq', function (inEvent, inSeq) {
                if (inSeq === 4) {
                    nb.model.set('dataReady', 'data-ready');
                }
            }, this);

            nb.model.onChange(nb.model.user, function (inEvent, inUser) {
                companyId = parseInt(inUser.get('companyId')) || null;
                var loginReady = inUser.get('loginReady');
                var userState = inUser.get('userState');
                if (!loginReady || userState === 1) {
                    products.set('loginReady', false);  //没登录  隐藏价格
                }
                this.getBannerList();
                this.getProductList(companyId);
                this.getBrandRecommend();
                this.getWineRecommend(companyId);
            }, this);


        },
        //微信登录
        _wxLogin: function () {
            var code = this.get('code');
            wxLogin({
                data: {
                    code: code
                },
                scope: this,
                success: function (inResp) {
                    if (inResp.phone) {
                        var token = inResp.token;
                        $.cookie('asc_b2b_userName', inResp.nickName);  //用户名
                        if (token) {
                            io.setToken(token);
                            $.cookie('asc_b2b_companyId', inResp.companyId);         //公司ID
                            $.cookie('asc_b2b_companyType', inResp.companyType);    //公司类型
                            $.cookie('asc_b2b_userType', inResp.innerUser);  //用户类型 内部用户（1：是；0：不是）
                            $.cookie('asc_b2b_userId', inResp.userId);   //userId
                            $.cookie('asc_b2b_token', token);    //唯一标示
                            $.cookie('asc_b2b_userState', inResp.state);   //有无企业信息

                            if (inResp.status === '1') {   //无企业信息填写提示 1
                                var dialog = require('../../../model/modal/CompleteInformation');
                                dialog.set('show', true);
                            } else {
                                var userModel = require('../../../model/User');
                                userModel.set('token', token);
                                nb.toast.setOpts({
                                    text: '登录成功！',
                                    status: 'success'
                                });
                            }
                        }
                    } else {
                        this._setCookieInfo(inResp);
                    }
                },
                error: function (inResp) {
                    nb.toast.setOpts({
                        text: inResp.error.info,
                        status: 'danger'
                    });
                    setTimeout(function () {
                        window.location.href = 'login.html';
                    }, 1000);
                }
            });
        },

        //获取微信登录数据 set Cookie
        _setCookieInfo: function (inResp) {
            $.cookie('asc_b2b_userName', inResp.nickName);
            $.cookie('asc_b2b_userId', inResp.userId);
            setTimeout(function () {
                window.location.href = 'bindUser.html';
            }, 1000);
        },

        //banner数据
        getBannerList: function () {
            getBannerList({
                scope: this,
                success: function (inResp) {
                    this.setOpts({
                        banner: {
                            swiper: {
                                items: inResp.bannerList
                            }
                        }
                    });
                    nb.model.setOpts({
                        initSwiper: new Date(),
                        dataReady: 'data-ready'
                    });
                    var seq = this.get('seq') + 1;
                    this.set('seq', seq);
                }
            })
        },

        //商品推荐数据
        getProductList: function (inId) {
            getProductList({
                data: {
                    companyId: inId || null
                },
                scope: this,
                success: function (inResp) {
                    this.setOpts({
                        products: {
                            items: inResp.productRecommendList
                        }
                    });
                    var seq = this.get('seq') + 1;
                    this.set('seq', seq);
                }
            })
        },

        //酒类推荐数据
        getWineRecommend: function (inId) {
            getWineRecommend({
                data: {
                    companyId: inId || null
                },
                scope: this,
                success: function (inResp) {
                    this.setOpts({
                        typeList: {
                            items: inResp.wineTypeRecommendList
                        }
                    });
                    var seq = this.get('seq') + 1;
                    this.set('seq', seq);
                }
            })
        },

        //品牌推荐数据
        getBrandRecommend: function () {
            getBrandRecommend({
                scope: this,
                success: function (inResp) {
                    $.each(inResp.brandRecommendList, function (inKey, inValue) { //  encodeURI
                        inValue.href = 'brandDetail.html?id=' + inValue.id + '&itemName=' + encodeURIComponent(inValue.nameEn);
                    });
                    this.setOpts({
                        brandList: {
                            items: inResp.brandRecommendList
                        }
                    });
                    var seq = this.get('seq') + 1;
                    this.set('seq', seq);
                }
            });
        }

    }
});




//////////////////
// WEBPACK FOOTER
// ../src/js/page/index/model/Content.js
// module id = 517
// module chunks = 6